import DgTreeSelect from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTreeSelect.install = function (Vue) {
  Vue.component(DgTreeSelect.name, DgTreeSelect)
}
export default DgTreeSelect

export { DgTreeSelect }